import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const CreateConfirm = ({ message, handleSubmit, handleFocusReset }) => {
    const yesRef = useRef(null);
    const noRef = useRef(null);

    useEffect(() => {
        if (yesRef.current) {
            yesRef.current.focus();
        }

        // Tally-like classic warning beep synthesizer
        const playAlertBeep = () => {
            try {
                const AudioContextClass = window.AudioContext || window.webkitAudioContext;
                if (!AudioContextClass) return;
                const ctx = new AudioContextClass();
                
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();
                
                osc.type = 'sine';
                osc.frequency.setValueAtTime(800, ctx.currentTime); // 800Hz is classic alert tone
                
                gain.gain.setValueAtTime(0.12, ctx.currentTime);
                // smooth fade out to prevent clicks
                gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.15);
                
                osc.connect(gain);
                gain.connect(ctx.destination);
                
                osc.start();
                osc.stop(ctx.currentTime + 0.15);
            } catch (e) {
                console.warn("Web Audio API not allowed or supported on this device:", e);
            }
        };

        if (['quit', 'logout', 'accept'].includes(message?.toLowerCase())) {
            playAlertBeep();
        }
    }, [message]);

    const form_action = message === 'Quit' ? 'quit' : 'submit';

    const handleKeyDown = (e) => {
        // Stop event propagation to prevent it from bubbling up to window after unmount
        e.stopPropagation();
        if (e.nativeEvent) {
            e.nativeEvent.stopImmediatePropagation();
        }

        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            if (document.activeElement === yesRef.current) {
                noRef.current?.focus();
            } else {
                yesRef.current?.focus();
            }
        } else if (e.key.toLowerCase() === 'y') {
            e.preventDefault();
            handleSubmit(new Event(form_action));
        } else if (e.key.toLowerCase() === 'n' || e.key === 'Escape') {
            e.preventDefault();
            handleFocusReset();
        }
    };

    return (
        <div
            onKeyDown={handleKeyDown}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1001,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
            <div
                style={{
                    width: '10%',
                    height: '100px',
                    borderWidth: 1,
                    borderColor: 'black',
                    borderStyle: 'solid',
                    background: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <p className='modal_message'>
                                {message} ?
                            </p>
                        </div>
                        <div className='col-12'>
                            <div className='row justify-content-center'>
                                <div className='col-3 m-0 p-0'>
                                    <Link ref={yesRef} tabIndex={0} style={{ textDecoration: 'none', color: '#000', outline: 'none' }} className="modal_link" onClick={() => { return (handleSubmit(new Event(form_action))) }} ><span style={{ color: 'red' }}>Y</span>es </Link>
                                </div>
                                <div className='col-2'>or</div>
                                <div className='col-3'>
                                    <Link ref={noRef} tabIndex={0} style={{ textDecoration: 'none', color: '#000', outline: 'none' }} className='modal_link' onClick={() => { return (handleFocusReset()) }}><span style={{ color: 'red' }}>N</span>o</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default React.memo(CreateConfirm)
